import Layout from 'components/Layout'
import { getds } from 'ds'
import { GetStaticPaths } from 'next'
import { getAuthorProps } from 'props-getters/author'
import { useCallback } from 'react'
import PageContainer from 'shared-components/service/PageContainer'
import AuthorNewTemplate from 'shared-components/templates/AuthorNewTemplate'
import { ExtractGetterProps } from 'shared-definitions/util-types'

const AuthorPage: React.VFC<ExtractGetterProps<typeof getAuthorProps>> = ({
  preview,
  page,
  common,
  ts,
}) => {
  const pageLoader = useCallback(
    async (pageNumber: number, perPage: number) => {
      const dataSource = await getds({ ts })
      const result = await dataSource.getAuthorPage(page.slug, pageNumber, perPage)
      if (!result.data || result.data.resource === 'redirect') {
        return []
      }
      return result.data.posts.items
    },
    [page.slug, ts]
  )

  return (
    <PageContainer
      layoutProps={{}}
      layout={Layout}
      props={{
        page,
        common,
        ts,
        preview,
      }}
    >
      <AuthorNewTemplate page={page} pageLoader={pageLoader} />
    </PageContainer>
  )
}

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = getAuthorProps()

export default AuthorPage
